// Import markdown files as strings
import offsetOvertimeMd from '../descriptions/surcharge_type/offset_overtime.md?raw';
import guaranteedRateMd from '../descriptions/surcharge_type/guaranteed_rate.md?raw';
import creditExtraTimeMd from '../descriptions/surcharge_type/credit_extra_time.md?raw';
import fixedFeeMd from '../descriptions/surcharge_type/fixed_fee.md?raw';
import hourlyPremiumMd from '../descriptions/surcharge_type/hourly_premium.md?raw';
import multiplierOffsetEscalationMd from '../descriptions/surcharge_escalation.md?raw';
import mealBreakDeadlineMd from '../descriptions/meal_break_deadline.md?raw';
import mealBreakLengthMd from '../descriptions/meal_break_length.md?raw';
import mealBreakTypeMd from '../descriptions/meal_break_type.md?raw';
import mealTriggerModeMd from '../descriptions/meal_trigger_mode.md?raw';
import countModeFieldsMd from '../descriptions/count_mode_fields.md?raw';

export const surchargeTypeDescriptions = {
  offset_overtime: offsetOvertimeMd,
  guaranteed_rate: guaranteedRateMd,
  credit_extra_time: creditExtraTimeMd,
  fixed_fee: fixedFeeMd,
  hourly_premium: hourlyPremiumMd,
} as const;

export const escalationDescriptions = {
  multiplier_offset_escalation: multiplierOffsetEscalationMd,
} as const;

export const fieldDescriptions = {
  meal_break_deadline: mealBreakDeadlineMd,
  meal_break_length: mealBreakLengthMd,
  meal_break_type: mealBreakTypeMd,
  meal_trigger_mode: mealTriggerModeMd,
  count_mode_fields: countModeFieldsMd,
} as const;

export type EscalationType = keyof typeof escalationDescriptions;

export type SurchargeType = keyof typeof surchargeTypeDescriptions;
